import styled from "styled-components";
import { useSelector } from "react-redux";
import LoadingGuts from "./LoadingGuts";

const Wrapper = styled.div`
  overflow-y: auto;
  position: fixed;
  width: 100%;
  height: 100vh; // for some reason 100vh instead of 100% fixes the bug on mobile pixel browser of when I scroll the header (with the url, tab count, etc.) away, things behind this overlay don't show up at the top or bottom.
  top: 0;
  bottom: 0;
  background: white;
`;

const MatchedVoterOverlay = () => {
  const isVoterSetUpLoading = useSelector((state) => state.userLoading.value);

  let overlayGuts = <></>;
  if (isVoterSetUpLoading) {
    overlayGuts = <LoadingGuts />;
  }

  return <Wrapper>{overlayGuts}</Wrapper>;
};

export default MatchedVoterOverlay;
